import { facadeApi } from 'api'
import { skipEmptyParams } from 'api/common/utils'
import { AssignmentType, FileTreeItem } from 'types/files/files'

interface Params {
  tenantId: string
  assignmentId: string
  assignmentType: AssignmentType
  sort?: string
}

export const fetchFilesTreeApi = ({ assignmentId, tenantId, assignmentType, sort }: Params) =>
  facadeApi.get<FileTreeItem[]>('file-manager/v1/files/tree', {
    params: skipEmptyParams({
      filter: {
        assignmentId,
        assignmentType,
      },
      sort,
    }),
    headers: {
      'X-Tenant-Id': tenantId,
    },
  })
